import { render, staticRenderFns } from "./ChattelMortgage.vue?vue&type=template&id=206eb6f0"
import script from "./ChattelMortgage.vue?vue&type=script&lang=js"
export * from "./ChattelMortgage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports